const ERROR_REASONS = {
  401: {
    default: {
      accounts_reason: 'unauthorized',
    },
  },
  429: {
    MAX_PHONE_VALIDATION_ATTEMPTS_REACHED: {
      accounts_reason: 'max_phone_validation',
      error: {
        title: 'Limite de verificações atingido',
        showContactUs: false,
        message: 'Esse telefone já foi utilizado para verificar uma conta nos últimos 30 dias.',
      },
    },
    default: {
      accounts_reason: 'rate_limit_exceeded',
    },
  },
  403: {
    PHONE_IN_BLACKLIST: {
      accounts_reason: 'phone_number_in_blacklist',
      error: {
        title: null,
        showContactUs: false,
        message: 'Este número não pode ser cadastrado novamente.',
      },
    },
    PHONE_IN_USE: {
      accounts_reason: 'phone_number_already_in_use',
      error: {
        title: 'Limite diário atingido para este número',
        showContactUs: false,
        message: 'Tente novamente daqui {LOCK_TIME}, ou use outro número de telefone.',
      },
    },
    ACCOUNT_LOCKED: {
      accounts_reason: 'account_locked',
      error: {
        title: 'Conta bloqueada.',
        showContactUs: true,
      },
    },
  },
  default: {
    accounts_reason: 'unexpected_status_code',
    error: {
      title: 'Falha em nosso sistema',
      showContactUs: false,
      message: 'Estamos trabalhando para resolver rapidinho. Tente novamente em alguns minutos.',
    },
  },
}

export const handlePhoneValidationExceptions = (error = {}) => {
  const { response: { status, data } = {} } = error

  const errorReason = ERROR_REASONS[status] || ERROR_REASONS.default
  const specificReason = errorReason[data?.message] || errorReason

  return {
    errorInfo: specificReason?.error || ERROR_REASONS.default.error,
    lurkerExtraData: {
      accounts_reason: specificReason.accounts_reason,
      accounts_status_code: status,
    },
  }
}
